import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { digObject } from '@domain-group/javascript-utils'

import {
  Box, Button, FileUploadZone, FormField, LoadingModule, ModalContext, SectionDivider, SidebarModal,
} from '@domain-group/suit-theme'

import useAttachments from '@hooks/useAttachments'
import useUppyAttachmentUpload from '@hooks/useUppyAttachmentUpload'

import AssetListItem from '@components/EntityAssets/AssetListItem'

const UploadEntityAssetsModal = (props) => {
  const {
    callbacks,
    modalKey,
    showModal,
  } = props

  const { closeModal } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { attachmentParams } = modalPayload

  const { attachable_id, attachable_type } = attachmentParams || {}

  const attachmentsPayload = useAttachments({
    entityKey: attachable_type + attachable_id,
    filters: attachmentParams,
    performHttpRequests: !!attachable_type && !!attachable_id,
  })

  const {
    filteredAttachments,
    hasFilteredAttachments,
    loading,
  } = attachmentsPayload

  const uppy = useUppyAttachmentUpload({ attachmentParams }, [...Object.values(attachmentParams)])

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Upload" titleSecondLine="Assets" />

      <SidebarModal.Content>
        <FormField label="*Upload Assets">
          <FileUploadZone uppy={uppy} />
        </FormField>

        <LoadingModule boxProps={{ marginTop: 'large' }} loading={loading} />

        {!loading && hasFilteredAttachments && (
          <>
            <SectionDivider marginTop="large">Uploaded Assets</SectionDivider>

            <Box flexDirection="column">
              {filteredAttachments.map(attachment => (
                <AssetListItem
                  attachment={attachment}
                  callbacks={callbacks}
                  key={attachment.id}
                />
              ))}
            </Box>
          </>
        )}
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          onClick={() => closeModal()}
          size="large"
        >
          Save Assets
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

UploadEntityAssetsModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

UploadEntityAssetsModal.defaultProps = {
  modalKey: 'UploadEntityAssetsModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <UploadEntityAssetsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
